import { SubTitle } from './Feedback.styled';

export const Notification = ({ message }) => {
  return <SubTitle>{message}</SubTitle>;
};